import useOrgBillingViewModel from './OrgBillingViewModel'
import useBillingViewModel from '@components/settings/Billing/BillingViewModel'

import { Link } from 'react-router-dom'
import { MdPayment } from 'react-icons/md'
import PurchaseCreditsDialog from '@components/shared/Dialogs/PurchaseCreditsDialog'
import { StripeElementsWrap } from '@components/shared/StripeElementsWrap'

const OrgBillingComponent = () => {
    
    const vm = useOrgBillingViewModel()
    const billingVm = useBillingViewModel()
    
    return (
        
        <div className="OrgBilling">
            
            <table className="table-auto w-auto text-lg">
                <tbody>
                    <tr>
                        <th>Organization Owner</th>
                        <td>{vm.user?.email}</td>
                    </tr>
                    <tr>
                        <th>Organization Balance</th>
                        <td>
                            ${(vm.credits.organization || 0).toFixed(2)}
                        </td>
                    </tr>
                </tbody>
            </table>
            
            <div className="flex items-center content-center justify-between mt-6">
                
                {!billingVm.loading && (
                    billingVm.stripeCards?.length > 0 ? (
                        <div className="flex items-center content-center justify-between gap-4">
                            <button
                                className="btn btn-primary"
                                onClick={() => vm.setPurchaseCreditsDialogOpen(true)}>
                                <MdPayment/>
                                Purchase Credits
                            </button>
                        </div>
                    ) : (
                        <div className="alert alert-warning block" role="alert">
                            <p>You do not have any credit cards on file.</p>
                            <p className="mt-2">
                                <Link className="underline" to="/settings/billing">Add a credit card</Link>
                                {' '}
                                to purchase credits.
                            </p>
                        </div>
                    )
                )}
            
            </div>
            
            {billingVm.stripeCards?.length > 0 && (
                <div className="mt-6">
                    <p><i>You will be asked to confirm purchase details.</i></p>
                    <p>
                        <i>
                            <Link className="underline" to="/settings">Visit your profile</Link>
                            {' '}
                            to update your billing information.
                        </i>
                    </p>
                </div>
            )}
            
            <PurchaseCreditsDialog
                user={vm.user}
                organization={vm.organization}
                paymentCards={billingVm.stripeCards} />
        
        </div>
        
    )
    
}

const OrgBilling = () => (
    <StripeElementsWrap>
        <OrgBillingComponent />
    </StripeElementsWrap>
)

export default OrgBilling
